//  CreateIndividualTest.js
//
//  Updated 2/8.
//
//  Abstract: Create new tests functional component. CRUD Firestore and Firebase.

//	React
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import axios from 'axios';
// import { authMiddleware } from '../../../services/auth';

//	Material-ui components
import { AppBar, Tabs, Tab, Box, Typography, CircularProgress, Card, CardActions, CardContent, Divider, Button, Grid, TextField, makeStyles, FormControl, Select, InputLabel, MenuItem, Container, Paper } from '@material-ui/core';

//	Date picker imports
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

//	CSS Styles
const useStyles = makeStyles((theme) => ({
    grid: {
        width: '50%'
        
    }
    // content: {
    //     flexGrow: 1,
    //     padding: theme.spacing(3),
    //     marginTop: '100px'
    // },
    // root: {
    //     flexGrow: 1,
    //     backgroundColor: theme.palette.background.paper,
    // },
    // details: {
    //     display: 'flex'
    // },
    // avatar: {
    //     height: 110,
    //     width: 100,
    //     flexShrink: 0,
    //     flexGrow: 0
    // },
    // locationText: {
    //     paddingLeft: '15px'
    // },
    // buttonProperty: {
    //     position: 'absolute',
    //     top: '50%'
    // },
    // uiProgess: {
    //     position: 'fixed',
    //     zIndex: '1000',
    //     height: '31px',
    //     width: '31px',
    //     left: '50%',
    //     top: '35%'
    // },
    // progess: {
    //     position: 'absolute'
    // },
    // uploadButton: {
    //     marginLeft: '8px',
    //     margin: theme.spacing(1)
    // },
    // customError: {
    //     color: 'red',
    //     fontSize: '0.8rem',
    //     marginTop: 10
    // },
    // submitButton: {
    //     marginTop: '10px'
    // }
}));

export default function CreateIndividualTest(props) {

    //  CSS styles
    const classes = useStyles();

    //  Props
    const { isButtonLoading, patientId, testId, patchIdsArray, plannedTestStartDate, onCreateTestSubmit, errors, onPatientIdChange, onTestIdChange, responsiblePhysician, onPatchIdsArrayChange, onPlannedTestStartDateChange, onResponsiblePhysicianChange, onErrorsChange } = props;

    //  Component rendering
    return (
        <>
            <form autoComplete="off" noValidate>
                <Grid container spacing={2} direction="row" className={classes.grid}>
                    <Grid item xs={6} >
                        {/* <form className={classes.container} noValidate>
                            <TextField id="date" label="Planned Test Start Date" type="date" defaultValue="2017-05-24" className={classes.textField} InputLabelProps={{ shrink: true }} />
                        </form> */}
                        <TextField
                            color="secondary"
                            label="Patient ID"
                            margin="dense"
                            name="patientId"
                            variant="outlined"
                            value={patientId}
                            onChange={onPatientIdChange}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            color="secondary"
                            label="Test ID"
                            margin="dense"
                            name="testId"
                            variant="outlined"
                            value={testId}
                            onChange={onTestIdChange}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            color="secondary"
                            label="Planned Test Start Date"
                            margin="dense"
                            name="plannedTestStartDate"
                            variant="outlined"
                            value={plannedTestStartDate}
                            onChange={onPlannedTestStartDateChange}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            color="secondary"
                            label="Responsible Physician"
                            margin="dense"
                            name="responsiblePhysician"
                            variant="outlined"
                            value={responsiblePhysician}
                            onChange={onResponsiblePhysicianChange}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            color="secondary"
                            label="Patch IDs Array"
                            margin="dense"
                            name="patchIdsArray"
                            variant="outlined"
                            value={patchIdsArray}
                            onChange={onPatchIdsArrayChange}
                        />
                    </Grid>
                </Grid>
            </form>
            <Button
                color="primary"
                variant="contained"
                type="submit"
                disableElevation
                disableRipple
                className={classes.submitButton}
                onClick={onCreateTestSubmit}
                disabled={
                    isButtonLoading ||
                    !patientId ||
                    !testId ||
                    !patchIdsArray
                }
            >
                Create Test {isButtonLoading && <CircularProgress size={15} className={classes.progess} />}
            </Button>
        </>
    );
}